// extracted by mini-css-extract-plugin
module.exports = {"EventList_list":"EventList_EventList_list__L7s5K","EventsList_heading":"EventList_EventsList_heading__Cm1wC"};